/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authApiKeysRegenerate } from "../../funcs/authApiKeysRegenerate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RegenerateScopedApiKeyRequest$inboundSchema,
};

export const tool$authApiKeysRegenerate: ToolDefinition<typeof args> = {
  name: "auth-api-keys-regenerate",
  description: `Rotate a scoped API key's secret

Issue a new plaintext secret for an existing key in place (id / scopes / binding preserved). Returned once.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authApiKeysRegenerate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
